<template>
    <!-- #################################################################### -->
    <!-- v-for cannot work at the top level, so at least one root is required -->
    <!-- #################################################################### -->
    <div>
        <div v-for="(parameter, index) in parameters" :key="parameter.jsonKey">
            <div v-if="judgeVisible(parameter)">
                <!-- ######################## -->
                <!-- selection based          -->
                <!-- ######################## -->
                <table v-if="needSelection(parameter)" class="detailed-table">
                    <tr :class="{'detailed-tr':(index != parameters.length -1), 'detailed-tr-bottom':(index == parameters.length -1)}">
                        <td class="detailed-left">{{getLocaledText(parameter.title)}}</td>
                        <td>{{getNameOfSelectedValue(parameter)}}</td>
                    </tr>
                </table>
                <!-- ######################## -->
                <!-- storage folder selection -->
                <!-- ######################## -->
                <table v-else-if="findCommand(parameter, 'selectStorageFolder')" class="detailed-table">
                    <tr :class="{'detailed-tr':(index != parameters.length -1), 'detailed-tr-bottom':(index == parameters.length -1)}">
                        <td class="detailed-left">{{getLocaledText(parameter.title)}}</td>
                        <td v-if="folderNameLoadingCounter != 0">loading...</td>
                        <td v-else>{{getStorageFolderShownValue(parameter)}}</td>
                    </tr>
                </table>
                <!-- ######################## -->
                <!-- normal input             -->
                <!-- ######################## -->
                <table v-else class="detailed-table">
                    <tr :class="{'detailed-tr':(index != parameters.length -1), 'detailed-tr-bottom':(index == parameters.length -1)}">
                        <td class="detailed-left">{{getLocaledText(parameter.title)}}</td>
                        <td v-if="!parameter.value && emptyIsAcceptable(parameter)"><span v-t="'message.item_default'"></span></td>
                        <td v-else>
                            <a v-if="parameter.link" :href="parameter.value" target="_blank">{{ parameter.value }}</a>
                            <span v-else>{{ parameter.value }}</span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import commonUtil from '@/components/commonutil.js';
import processorTemplateUtil from "@/components/pc/setting/ai-app/AiAppSettingUtil";

export default {
    props: {
        processor: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            parameters: null,
            folderNameLoadingCounter: 0,
        };
    },

    created: function() {
        this.parameters = this.processor.parameters;
    },

    methods: {
        getLocaledText(item) {
            return processorTemplateUtil.getLocaledText(this.$i18n, item);
        },
        needSelection(item) {
            return processorTemplateUtil.needSelection(item);
        },
        judgeVisible(item) {
            return processorTemplateUtil.judgeVisible(item);
        },
        getNameOfSelectedValue(item) {
            return processorTemplateUtil.getNameOfSelectedValue(this.$i18n, item);
        },
        findCommand(parameter, command) {
            return processorTemplateUtil.findCommand(parameter, command);
        },
        emptyIsAcceptable(parameter) {
            if ('validationRule' in parameter) {
                if (parameter.validationRule.startsWith('req')) {
                    return false;
                }
            }
            return true;
        },
        getStorageFolderShownValue(parameter) {
            if (parameter.shownValue == null) {
                this.requestStorageFolderShownValue(parameter);
                return 'loading...';
            }
            if (parameter.shownValue == '') {
                return commonUtil.getMessageText(this.$i18n, 'info_empty_storage_selection');
            }
            return parameter.shownValue;
        },
        async requestStorageFolderShownValue(parameter) {
            let keyVaultId = null;
            for (let param of this.processor.parameters) {
                if (param.jsonKey == 'keyVaultId') {
                    keyVaultId = param.candidates[param.value].value;
                    break;
                }
            }
            this.folderNameLoadingCounter++;
            let folderName = await processorTemplateUtil.requestStorageFolderNameIfRequired(keyVaultId, parameter.value);
            parameter.shownValue = folderName;
            this.folderNameLoadingCounter--;
        },
    }
}
</script>

<style scoped>
.template-select-button {
    width: 200px;
    margin-top: 15px;
    margin-bottom: 15px;
}
.step-dialog-title >>> .el-step__title {
    font-size: 12px ;
    line-height: 25px ;
}
.step-dialog-title >>> .el-step__head.is-success {
    color: #5171cb;
    border-color: #5171cb;
}
.step-dialog-title >>> .el-step__title.is-success {
    color: #5171cb;
}
.step-dialog-title {
    padding: 20px;
    width: 500px;
}
.item-titlebox {
    width: 100%;
    background-color: #f6f6f6;
    display: table;
    border-bottom: 1px #fff solid;
    margin-top: 10px;
    margin-bottom: 10px;
}
.item-titlebox-left {
    padding: 10px 0 10px 15px;
    width: 50%;
    display: table-cell;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.input-form-setting {
    padding-left: 15px;
    text-align: left;
}
.detailed-header {
    width: 95%;
    background-color: #f6f6f6;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 12px;
}
.detailed-header-small {
    width: 70%;
    background-color: #f6f6f6;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 12px;
}
.detailed-table {
    width: 95%;
    margin-left: 20px;
}
.detailed-tr {
    border-bottom:1px #eee solid;
    overflow-wrap: anywhere;
}
.detailed-tr-bottom {
    border-bottom:none;
    overflow-wrap: anywhere;
}
.detailed-left {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 40%;
}
.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}


</style>
